import Icon from '../Icon.vue'

Icon.register({
  'help': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 18C4.486 20 0 15.514 0 10S4.486 0 10 0s10 4.486 10 10-4.486 10-10 10z'
      },
      {
        d: 'M9 14.015h2v-2L9 12v2.015zM9.007 8.018c-.044-.624.274-1.161.801-1.161.502 0 .753.324.753.762 0 .201-.152.49-.339.702l-.893 1.026c-.247.333-.321.499-.323.665v1l1.994.003.001-.276c0-.212.013-.357.125-.495l.851-1.008c.349-.451.639-.952.639-1.605 0-1.74-1.33-2.631-2.808-2.631C8.292 5 7 6.315 7 8.018h2.007z'
      }
    ]
  }
})
